import { type FinancialAccountConstructor } from '../../entities/FinancialAccount'
import { type FinancialAccountApiModel } from '../api-models/FinancialAccountApiModel'

export const mapFinancialAccountApiModel = (
  data: FinancialAccountApiModel
): FinancialAccountConstructor => ({
  id: data.id,
  status: data.status,
  type: data.type,
})
